import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';


@Component({
    selector: 'default-availability-summary',
    templateUrl: './default-availability-summary.component.html',
    styleUrls: ['./default-availability-summary.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class DefaultAvailabilitySummaryComponent implements OnInit {
  private readonly _componentName = 'DefaultAvailabilitySummaryComponent';
  private _defaultOpen : boolean;

  constructor() { }

  ngOnInit() {
  }

  
  
  public get defaultOpen() : boolean {
    return this._defaultOpen;
  }

  @Input()
  public set defaultOpen(v : boolean) {
    this._defaultOpen = v;

    console.log(`${this._componentName}.defaultOpen set v=`,v); 
  }
  

}
